import { Button, Card, CardActions } from '@mui/material';
import { useRemoteAccess, useUpdateRemoteAccess } from './remote-access.hook';
import { RemoteAccessFormFields } from './remote-access.form-fields';
import { Formik, FormikProps } from 'formik';
import { formTools, FormValues } from './remote-access.form-tools';
import { LoadingBanner } from 'shared/ui/loading-banner';
import { ErrorBanner } from 'shared/ui/error-banner';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { useSnack } from 'shared/ui/snack';


type Props = {
    userId: number
};

export const UserRemoteAccessSettings = ({ userId }: Props) => {
  const { showSuccess, showError } = useSnack();
  const { data, isLoading, error } = useRemoteAccess(userId);
  const update = useUpdateRemoteAccess(userId);
  const handleSubmit = async (formValues: FormValues) => {
    try {
      await update(formTools.toUpdateDto(userId, formValues));
      showSuccess('Данные успешно обновлены');
    } catch (e) {
      showError('Ошибка обновления данных', e);
    }
  };
  if (error) return <ErrorBanner errorMessage={extractNestJsErrorMessage(error)}/>;
  if (isLoading || !data) return <LoadingBanner/>;
  return (
    <>
      <Card sx={{ p: 2, gap: 2 }}>
        <Formik
          initialValues={formTools.fromDto(data)}
          validate={formTools.validate}
          onSubmit={handleSubmit}
        >
          {({ submitForm, dirty, isSubmitting, isValid, ...props }: FormikProps<FormValues>) => (
            <>
              <RemoteAccessFormFields
                {...props}
                dirty={dirty}
                isSubmitting={isSubmitting}
                isValid={isValid}
                submitForm={submitForm}
              />
              <CardActions>
                <Button
                  sx={{ ml: 'auto', mr: 1 }}
                  variant="contained"
                  onClick={() => submitForm()}
                  disabled={!dirty || isSubmitting || !isValid}
                >
                  Сохранить
                </Button>
              </CardActions>
            </>
          )}
        </Formik>
      </Card>
    </>
  );
};
